import { Directive, inject, input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { catchError, finalize, of, switchMap, tap, throwError } from 'rxjs';

import {
  LoaderService,
  NotesApiService,
  NotesModalService,
} from '@shared/services';
import { ToastService } from '@shared/components/toast';
import { GenericApplicationSections } from '@shared/interfaces';

@Directive({
  selector: '[appAddNote]',
  standalone: true,
  host: {
    '(noteClick)': 'onHandleAddNote()',
  },
})
export class AddNoteDirective {
  private readonly _loader = inject(LoaderService);
  private readonly _toastService = inject(ToastService);
  private readonly _notesApiService = inject(NotesApiService);
  private readonly _notesModalService = inject(NotesModalService);

  public readonly section = input.required<GenericApplicationSections>({
    alias: 'appAddNote',
  });

  protected async onHandleAddNote(): Promise<void> {
    const section = this.section();
    const result = await this._notesModalService.onOpenModalAddNote(section);

    if (!result) return;

    const params = { section, ...result };

    of(null)
      .pipe(
        tap(() => this._loader.show()),
        switchMap(() => this._notesApiService.addNote(params)),
        tap(() =>
          this._toastService.show({
            message: 'Note added successfully',
            type: 'success',
          }),
        ),
        catchError((error: HttpErrorResponse) => {
          this._toastService.show({
            message: 'Failed to add note. Please try again.',
            type: 'error',
          });
          return throwError(() => error);
        }),
        finalize(() => this._loader.hide()),
      )
      .subscribe();
  }
}
